import React, { useEffect, useState } from 'react';
import './Skills.css';
import { getSkills } from '../queries/getSkills';

import { FaReact, FaNodeJs, FaAws, FaDocker, FaJava, FaPython, FaJs, FaDatabase, FaBrain, FaCode, FaChartLine, FaFileExcel, FaLock, FaProjectDiagram, FaGithub, FaCloud } from 'react-icons/fa';
import { SiRubyonrails, SiTypescript, SiPostgresql, SiMysql, SiNetlify, SiHtml5, SiCss3, SiMongodb, SiSupabase, SiVercel, SiPytorch, SiTensorflow, SiRender, SiSpacy, SiFlask, SiSqlalchemy, SiWebassembly } from 'react-icons/si';
import { Skill } from '../types';

const iconMap: { [key: string]: JSX.Element } = {
  SiRubyonrails: <SiRubyonrails />,
  FaNodeJs: <FaNodeJs />,
  FaJava: <FaJava />,
  FaReact: <FaReact />,
  SiTypescript: <SiTypescript />,
  FaAws: <FaAws />,
  FaDocker: <FaDocker />,
  SiPostgresql: <SiPostgresql />,
  SiMysql: <SiMysql />,
  SiNetlify: <SiNetlify />,
  SiHtml5: <SiHtml5 />,
  SiCss3: <SiCss3 />,
  FaPython: <FaPython />,
  FaJs: <FaJs />,
  FaDatabase: <FaDatabase />,
  FaBrain: <FaBrain />,
  FaCode: <FaCode />,
  FaChartLine: <FaChartLine />,
  FaFileExcel: <FaFileExcel />,
  FaLock: <FaLock />,
  FaProjectDiagram: <FaProjectDiagram />,
  FaGithub: <FaGithub />,
  FaCloud: <FaCloud />,
  SiMongodb: <SiMongodb />,
  SiSupabase: <SiSupabase />,
  SiVercel: <SiVercel />,
  SiPytorch: <SiPytorch />,
  SiTensorflow: <SiTensorflow />,
  SiRender: <SiRender />,
  SiSpacy: <SiSpacy />,
  SiFlask: <SiFlask />,
  SiSqlalchemy: <SiSqlalchemy />,
  SiWebassembly: <SiWebassembly />,
};


const Skills: React.FC = () => {

  const [skillsData, setSkillsData] = useState<Skill[]>([]);

  useEffect(() => {
    async function fetchSkills() {
      const data = await getSkills();
      setSkillsData(data);
    }

    fetchSkills()
  }, []);

  if (skillsData.length === 0) return <div>Loading...</div>;

  const skillsByCategory = skillsData.reduce((acc: any, skill: any) => {
    if (!acc[skill.category]) acc[skill.category] = [];
    acc[skill.category].push(skill);
    return acc;
  }, {});


  return (
    <div className="skills-container">
      {Object.keys(skillsByCategory).map((category, index) => (
        <div key={index} className="skill-category">
          <h3 className="category-title">{category}</h3>
          <div className="skills-grid">
            {skillsByCategory[category].map((skill: any, idx: number) => (
              <div key={idx} className="skill-card">
                <div className="icon">{iconMap[skill.icon] || <FaReact />}</div>
                <h3 className="skill-name">
                  {skill.name.split('').map((letter: any, i: number) => (
                    <span key={i} className="letter" style={{ animationDelay: `${i * 0.05}s` }}>
                      {letter}
                    </span>
                  ))}
                </h3>
                <p className="skill-description">{skill.description}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skills;
